module.exports = __webpack_public_path__ + "static/media/girl-eating.e5f5c83c.png";